import React,{useState} from 'react'
import {
	useSelector,
	useDispatch
} from 'react-redux'
import {
	selectTrainerParam,
	deleteClient,
	selectUserById,
	selectClientsById,
	clearTrainerNewMessageFlag
} from '../../users/usersSlice'
import {
	updateShow as updateShowChat,
	updateRecipient as updateChatRecipient
} from '../../chat/chatSlice'
import {
	getChatRooms,
	getChatRoom,
	selectMemberPrivateRoomId,
	selectMemberRoomNewMessageCount,
	setShow as setShowMessageCenter
} from '../../MessageCenter/messageCenterSlice'
import {fullBasePath} from '../../../util/util'
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import {Link} from 'react-router-dom';
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import classes from './RowOptions.module.css'

import AlertBubble from '../../AlertBubble/AlertBubble'
import { updateCalendarClientSelected } from '../../../state/events'

const RowOptions = ({clientId})=>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch();
	const trainerParam = useSelector(selectTrainerParam)
	const [open,setOpen] = useState(false)
	const client = useSelector( state => selectClientsById( state, clientId ) )
	const privateChatRoomId = useSelector(
		state => selectMemberPrivateRoomId(state,clientId)
	)
	const openChatHandler = () => {
		dispatch(getChatRoom({
			room_id:privateChatRoomId
		}))
		dispatch(setShowMessageCenter(true))
	} 

	const newMessageCount = useSelector(
		state=>selectMemberRoomNewMessageCount(state,privateChatRoomId)
	)

	return (
		<div className={classes.RowOptions}>
			<Button
				className={[classes.OptionsToggle,open?classes.Hidden:''].join(' ')}
				variant="outline-secondary"
				size="sm"
				onClick={()=>setOpen(!open)}
			>
				<i className="fas fa-ellipsis-h"></i>
				{newMessageCount?(<AlertBubble />):null}
			</Button>
			<div className={[classes.OptionsMenu,open?classes.Open:''].join(' ')}>
				<OverlayTrigger overlay={
					<Tooltip>
						Metric Progress Graphs
					</Tooltip>
				}>
					<Button
						className={`m-1 ${classes.metricBTN}`}
						size="sm"
						variant="outline-info"
						style={{
							color:"#9400d3",
							borderColor:"#9400d3",
						}}
						as={Link}
						to={`/metric-graphs?clientId=${client.user_id_number}&${trainerParam}`}
					>
						<i className="fas fa-chart-line"></i>
					</Button>
				</OverlayTrigger>

				<OverlayTrigger overlay={
					<Tooltip>
						Exercise Progress Graphs
					</Tooltip>
				}>
					<Button
						className={`m-1 ${classes.progressBTN}`}
						size="sm"
						variant="outline-info"
						style={{
							color:"#d39400",
							borderColor:"#d39400",
						}}
						as={Link}
						to={`/exercise_progress/?client=${client.user_id_number}&${trainerParam}`}
					>
						<i className="fas fa-dumbbell"></i>
					</Button>
				</OverlayTrigger>	
				<OverlayTrigger overlay={
					<Tooltip>
						Wearable Data Graphs
					</Tooltip>
				}>

					<Button
						className={`m-1 ${classes.healthBTN}`}
						size="sm"
						variant="outline-primary"
						style={{
							color:"rgb(255 0 24)",
							borderColor:"#838181",
						}}
						as={Link}
						to={`/wearables?clientId=${client.user_id_number}&${trainerParam}`}
					>
						<i className="fas fa-heart"></i>
					</Button>
				</OverlayTrigger>

			<OverlayTrigger overlay={
				<Tooltip>
					Achievements
				</Tooltip>
			}>
				<Button
					className="m-1"
					size="sm"
					variant="outline-info"
					as={Link}
					to={`/achievements?client=${client.user_id_number}&${trainerParam}`}
				>
					<i className="fa fa-trophy"></i>
				</Button>
			</OverlayTrigger>
			
			<OverlayTrigger overlay={
				<Tooltip>
					Progress Pictures
				</Tooltip>
			}>
				<Button
					variant='outline-primary'
					className='m-1'
					size='sm'
					as={Link}
					to={`/photo_reel?client=${client.user_id_number}&${trainerParam}`}
				>
					<i className="far fa-images"></i>
				</Button>
			</OverlayTrigger>
			
				
			<OverlayTrigger overlay={
				<Tooltip>
					Open Chat
				</Tooltip>
			}>
				<Button
					className="m-1 position-relative"
					size="sm"
					variant="outline-success"
					onClick={openChatHandler}
				>
					<i className="fas fa-comment"></i>
					{newMessageCount?(<AlertBubble />):null}
				</Button>
			</OverlayTrigger>

				<OverlayTrigger overlay={
					<Tooltip>
						Delete this client
					</Tooltip>
				}>
					<Button
						className="m-1"
						size="sm"
						variant="outline-danger"
						onClick={()=>{
							if(window.confirm('Are you sure you would like to delete this client and all their data?')){
								statusDispatch(deleteClient(client.user_id_number),"client","delete").then(()=>{
									dispatch(getChatRooms())
								})
							} 
						}}
					>
						<i className="fas fa-trash"></i>
					</Button>

				</OverlayTrigger>

				<Button
					className={[classes.OptionsToggle,'m-1'].join(' ')}
					variant="outline-secondary"
					size="sm"
					onClick={()=>setOpen(!open)}
				>
					<i className="fas fa-ellipsis-h"></i>
				</Button>
			</div>
		</div>
	) 
}


export default RowOptions